// src/unicodex_ui/pages/RegisterPage.jsx
import React from "react";
import "../styles/FormLayout.css";
import "../styles/RegisterPage.css";
import TopNav from "../components/TopNav";
import FooterBar from "../components/FooterBar";

function RegisterPage() {
  function handleSubmit(e) {
    e.preventDefault();
    // Later: connect to backend for batch registration
  }

  return (
    <div className="ucx-body">
      <TopNav />

      <main className="ucx-main">
        <section className="ucx-section">
          <div className="ucx-container ucx-max-700">
            <h1>Register a Product Batch</h1>
            <p>
              Use this form to register a new product and batch for UNI-CODEX
              code assignment. Only approved manufacturers with a valid
              UNI-CODEX prefix should use this form.
            </p>

            <form
              className="ucx-form"
              id="ucx-register-form"
              onSubmit={handleSubmit}
            >
              <fieldset className="ucx-fieldset">
                <legend>Manufacturer Details</legend>

                <label htmlFor="prefix">UNI-CODEX Prefix</label>
                <input
                  type="text"
                  id="prefix"
                  name="prefix"
                  required
                  placeholder="Assigned prefix (e.g. UCX01)"
                />

                <label htmlFor="manufacturer_name">
                  Registered Manufacturer Name
                </label>
                <input
                  type="text"
                  id="manufacturer_name"
                  name="manufacturer_name"
                  required
                />

                <label htmlFor="contact_email">Contact Email</label>
                <input
                  type="email"
                  id="contact_email"
                  name="contact_email"
                  required
                />
              </fieldset>

              <fieldset className="ucx-fieldset">
                <legend>Product &amp; Batch Details</legend>

                <label htmlFor="product_name">Product Name</label>
                <input
                  type="text"
                  id="product_name"
                  name="product_name"
                  required
                />

                <label htmlFor="category">Category</label>
                <input
                  type="text"
                  id="category"
                  name="category"
                  placeholder="e.g. Cosmetics, Pharmaceuticals, Food"
                />

                <label htmlFor="packaging">Packaging Description</label>
                <input
                  type="text"
                  id="packaging"
                  name="packaging"
                  placeholder="Box, blister pack, bottle, etc."
                />

                <label htmlFor="batch_size">Batch Size (units)</label>
                <input
                  type="number"
                  id="batch_size"
                  name="batch_size"
                  min="1"
                  required
                />

                <label htmlFor="manufacture_date">Manufacture Date</label>
                <input
                  type="date"
                  id="manufacture_date"
                  name="manufacture_date"
                  required
                />

                <label htmlFor="expiry_date">
                  Expiry Date (if applicable)
                </label>
                <input type="date" id="expiry_date" name="expiry_date" />
              </fieldset>

              <button type="submit" className="ucx-btn ucx-btn-primary">
                Submit Batch Registration
              </button>
            </form>

            <p className="ucx-small ucx-top-margin">
              Once approved, UNI-CODEX will generate a secure range of codes for
              this batch, which you can embed into labels, packaging, or digital
              identifiers.
            </p>
          </div>
        </section>
      </main>

      <FooterBar />
    </div>
  );
}

export default RegisterPage;
